import type { FunctionComponent } from 'react'
import React from 'react'

import { Icon } from '../../Icon'
import type { Icon as IconProps } from '../../Icon/Icon'
import styles from '../Icons.module.scss'

export const DoubleArrowIcon: FunctionComponent<IconProps> = ({
  fill,
  width = 30,
  height = 10,
  ...rest
}) => {
  return (
    <Icon fill={fill} height={height} viewBox={`0 0 ${width} ${height}`} width={width} {...rest}>
      <g
        fill="#0050B3"
        className={styles.interactiveColor}
        fillRule="evenodd"
        transform="translate(0 .5)"
      >
        <path d="M.539 3.41553046C-.179666667 3.89767245-.179666667 5.10238455.539 5.58452654L2.95983333 7.20709503 5.38183333 8.83094924C6.1005 9.31180551 7 8.71009231 7 7.74580834L7 4.50067136 7 1.25424866C7 .289964688 6.1005-.31174851 5.38183333.169107763L2.95983333 1.79296197.539 3.41553046ZM29.461 3.41553046C30.1796667 3.89767245 30.1796667 5.10238455 29.461 5.58452654L27.0401667 7.20709503 24.6181667 8.83094924C23.8995 9.31180551 23 8.71009231 23 7.74580834L23 4.50067136 23 1.25424866C23 .289964688 23.8995-.31174851 24.6181667.169107763L27.0401667 1.79296197 29.461 3.41553046Z" />
        <polygon points="6 5.5 24 5.5 24 3.5 6 3.5" />
      </g>
    </Icon>
  )
}
